import { render, staticRenderFns } from "./ProductUpdatesCenterPopUp.vue?vue&type=template&id=de04c0d8&scoped=true&"
import script from "./ProductUpdatesCenterPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductUpdatesCenterPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpdatesCenterPopUp.vue?vue&type=style&index=0&id=de04c0d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de04c0d8",
  null
  
)

export default component.exports